import { useState } from 'react';

export function useSelected<T extends { id: string }>(): [
  T[],
  (i: T) => void,
  (i: T[]) => void,
  () => void,
] {
  const [selected, setSelected] = useState<T[]>([]);

  // TA-10299: functional updater on every branch — toggleSelected/selectAll
  // are re-created on every render (they close over that render's `selected`
  // snapshot), so a caller that invokes one of them more than once from the
  // same handler (e.g. a loop awaiting an async task per item) keeps calling
  // that ONE stale closure for its entire run, no matter how many re-renders
  // happen in between. Reading `current` from the updater (rather than the
  // outer `selected`) is what makes repeated/rapid calls correct regardless
  // of which render's closure is doing the calling.
  const toggleSelected = (i: T) => {
    setSelected((current) => {
      const arr = current.filter((item) => item.id !== i.id); // rm
      return arr.length !== current.length ? arr : [...current, i]; // add
    });
  };

  const selectAll = (data: T[]) => {
    setSelected((current) => (current.length !== data.length ? data : []));
  };

  const unSelectAll = () => {
    setSelected([]);
  };

  return [selected, toggleSelected, selectAll, unSelectAll];
}
